export default __webpack_public_path__ + "static/media/Darkblade's Belt of Consumed Souls.af5a19db.jpg";